import {IPaginatedData, IPaginatorParams, TableSort} from '@/types/table';
import {AppUtils} from '@/utils/AppUtils.ts';

export class TableUtils {
    public static sort2String<T>(sort?: TableSort<T>): string | undefined {
        if (!sort) {
            return undefined
        }

        return Object.keys(sort).map((k) => {
            return `${k}:${sort[k as keyof TableSort<T>]}`
        }).join(',')
    }


    public static paginateArray<T>(allItems: T[], paginator: IPaginatorParams<T>): IPaginatedData<T> {

        const limit = paginator.limit ?? 50
        const total = allItems?.length
        const currentPage = paginator.page ?? 1
        const totalPages = Math.ceil(total / limit)

        const sort = paginator?.sort ?? {} as TableSort<T>
        if (Object.keys(sort ?? {}).length > 0) {
            allItems = (Object.keys(sort) as (keyof T)[])
                .reduce<T[]>((a, b) => {
                    return AppUtils.sortBy<T>(a, b, sort[b])
                }, allItems)
        }

        const startIndex = (currentPage - 1) * limit;
        const endIndex = startIndex + limit;
        const items = allItems?.slice(startIndex, endIndex);

        return {
            limit,
            total,
            currentPage,
            totalPages,
            items
        }
    }

}
